var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSplitIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2129_658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9655 1.08301L8.93216 0.0191634C8.25356 -0.100493 7.60644 0.352632 7.48678 1.03123L7.42969 1.35507C8.30222 1.46257 9.03937 2.09113 9.27147 2.95723L9.64019 4.33332C9.83541 4.24866 10.0567 4.21816 10.282 4.25788C10.7094 4.33326 11.0373 4.64085 11.1594 5.02794C11.4066 4.70598 11.82 4.52907 12.2474 4.60444C12.8591 4.71232 13.2676 5.29566 13.1597 5.90738C12.9253 7.23657 11.499 8.30491 10.8221 8.74432L11.8555 12.6013C11.9109 12.808 11.934 13.0159 11.9289 13.2197L12.7984 13.373C13.477 13.4927 14.1242 13.0396 14.2438 12.361L15.9776 2.52844C16.0972 1.84979 15.6441 1.20266 14.9655 1.08301Z",
    fill: "#1D4ED8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37085 3.19948C8.22148 2.64204 7.71738 2.27438 7.16648 2.27441C7.0596 2.27441 6.95092 2.28826 6.84276 2.31723L0.925072 3.90285C0.259478 4.0812 -0.135522 4.76535 0.0428221 5.43095L2.62692 15.075C2.77629 15.6324 3.28038 16 3.83129 16C3.93817 16 4.04685 15.9862 4.15498 15.9572L10.0727 14.3716C10.7383 14.1932 11.1333 13.5091 10.9549 12.8435L8.37085 3.19948ZM3.76595 9.7917C3.6656 9.70342 3.62813 9.56351 3.67088 9.43692L4.57576 6.7576C4.65145 6.53348 4.93088 6.4586 5.10851 6.61485L7.23182 8.48279C7.33217 8.57107 7.36963 8.71098 7.32688 8.83757L6.42201 11.5169C6.34632 11.741 6.06688 11.8159 5.88926 11.6596L3.76595 9.7917Z",
    fill: "#1D4ED8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2129_658"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplitIcon);
export default __webpack_public_path__ + "static/media/split-icon.ff370e9ebc6db32c878f3d3ba9d034b6.svg";
export { ForwardRef as ReactComponent };